import './infographic-preview.scss';
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from 'react';
import { downloadFile } from '../../utility/download-file.utility';
import { CircularProgress } from '@mui/material';

const InfographicPreviewModal = ({ show, onClose, infoId }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [fullImage, setFullImage] = useState('');

    useEffect(() => {
        const fetchFullImage = async () => {
            try {
                const fullImgSrc = await downloadFile(infoId, 'full-image.png', 'full');

                if (fullImgSrc) {
                    setFullImage(fullImgSrc);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Error fetching thumbnail:", error);
                setIsLoading(false);
            }
        };

        fetchFullImage();
    }, []);

    const handleClose = () => {
        onClose();
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Body className='info-preview-modal-wrapper'>
                <FontAwesomeIcon icon={faClose} className="modal-icon-close" onClick={handleClose}></FontAwesomeIcon>

                {
                    isLoading ?
                        <CircularProgress /> :
                        fullImage && <img src={fullImage} className='full-image' />
                }
            </Modal.Body>
        </Modal>
    )
}

export default InfographicPreviewModal;